export class PrescriptionModel {
    presc_code: string
    presc_text: string
    presc_reason_desc: string

    constructor(
        presc_code: string,
        presc_text: string,
        presc_reason_desc: string
    ) {
        this.presc_code = presc_code
        this.presc_text = presc_text
        this.presc_reason_desc = presc_reason_desc
    }
}